<script>
import { Tabs, Tab } from 'vant'
import OrganizationStaffList from '@/components/org/OrganizationStaffList'
import BottomToolbar from '@/components/org/BottomToolbar'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-staff-list',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-tabs': Tabs,
        'van-tab': Tab,
        'organization-staff-list': OrganizationStaffList,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            staffList: null,
            organizationId: null,
            selectedRole: null,
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        staffListField() {
            if (this.staffList) {
                console.log('selectedRole', this.selectedRole)
                if (this.selectedRole == 1) {
                    return this.staffList.filter(staff => staff.role == '2')
                }
                else {
                    return this.staffList.filter(staff => staff.role == '1')
                }
            }
            return []
        },
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onStaffRoleTabClick(index) {
            console.log('onStaffRoleTabClick', index)
            this.$emit('custom-event', {
                type: 'tab',
                data: {
                    index: index,
                    parameters: {
                        staffRole: index == 0 ? '1' : '2',
                        organizationId: this.organizationId
                    }
                }
            })
        },
        onStaffItemClick(item) {
            console.log('onStaffItemClick', item)
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgDetailStaff',
                    params: {
                        id: item.id
                    },
                    query: {
                        organizationId: this.organizationId,
                        isMatchOperator: (item.role == '2') ? 'true' : 'false'
                    }
                }
            })
        },
        onStaffItemCreate() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgCreateStaff',
                    query: {
                        organizationId: this.organizationId
                    }
                }
            })
        },
        onStaffInvite(item) {
            console.log('onStaffInvite', item)
            this.$emit('custom-event', {
                type: 'invite',
                data: {
                    id: item.id,
                    organizationId: this.organizationId,
                    role: item.role,
                    roleLabel: item.roleLabel
                }
            })
        },
        onCreateBtnClick() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgCreateStaff',
                    query: {
                        organizationId: this.organizationId
                    }
                }
            })
        },
    },
}
</script>
<template>
    <div class="staff-list">
        <van-tabs v-model="selectedRole" sticky
            offset-top="43" @click="onStaffRoleTabClick">
            <van-tab :title="locale['role-option-1']">
                <organization-staff-list
                    :staffList="staffListField"
                    :staffEmptyHint="locale['staff-empty-hint']"
                    :staffInviteLabel="locale['staff-invite-label']"
                    @create-item="onStaffItemCreate"
                    @click-item="onStaffItemClick"
                    @invite-staff="onStaffInvite"
                />
            </van-tab>
            <van-tab :title="locale['role-option-2']">
                <organization-staff-list
                    :staffList="staffListField"
                    :staffEmptyHint="locale['staff-empty-hint']"
                    :staffInviteLabel="locale['staff-invite-label']"
                    @create-item="onStaffItemCreate"
                    @click-item="onStaffItemClick"
                    @invite-staff="onStaffInvite"
                />
            </van-tab>
        </van-tabs>
        <bottom-toolbar 
            type="button" 
            :mainButtonLabel="locale['create']"
            @click-main-button="onCreateBtnClick"
        />
    </div>
</template>